
<template>
  <div class="team-center">
    <div id="clan" v-show="selectedNavItem == 'team'">
      <ul v-if="teams" class="teams" ref="teams">
        <li
          v-for="(team, key) in teams"
          :key="key"
          @click="toDetail(team.teamCode, team.name)"
        >
          <div class="left">
            <div class="icon">
              <div
                class="head"
                :style="{
                  'background-image': `url(${team.avatar})`,
                }"
              ></div>
              <div class="frame"></div>
            </div>
            <div class="name">{{ team.name }}</div>
          </div>
          <ui-frame-bg
            class="focus-box"
            :colorType="team.isFollowed ? 'blue' : 'yellow'"
            @click.native.stop="handleFocus(team.teamCode, !team.isFollowed, team.name)"
          >
            <i :class="{ focus: !team.isFollowed, unfocus: team.isFollowed }"></i>
            <div class="label-box">
              <span class="label-shadow">{{ team.isFollowed ? '已关注' : '关注' }}</span>
              <span class="label-text">{{ team.isFollowed ? '已关注' : '关注' }}</span>
            </div>
          </ui-frame-bg>
        </li>
        <li v-if="teams.length % 2 != 0" :style="{ opacity: 0 }"></li>
        <div class="placeholder"></div>
      </ul>
      <Prompt ref="prompt"></Prompt>
    </div>
    <Star v-show="selectedNavItem === 'star'" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import * as api from '@/service/index'
import Prompt from '@/components/prompt'
import Star from '@/components/star/index.vue'
import UiFrameBg from '@/components/ui-frame-bg'

export default {
  components: {
    Prompt,
    Star,
    UiFrameBg
  },
  data() {
    return {
      teams: [],
      inRequire: false,
      selectedNavItem: 'team'
    }
  },
  computed: {
    ...mapState(['token', 'uid', 'seasonInfo'])
  },
  watch: {
    seasonInfo: {
      handler(newVal) {
        if (newVal && newVal.id) {
          // 获取战队信息
          this.getTeamsInfo(newVal.id)
        }
      },
      immediate: true,
      deep: true
    }
  },
  beforeRouteLeave(to, from, next) {
    if (from.name == 'Teams') {
      this.cacheScroll()
    }
    next()
  },
  created() {
    window.addEventListener('beforeunload', () => this.cacheScroll())
  },
  destroyed() {
    window.removeEventListener('beforeunload', () => this.cacheScroll())
  },
  methods: {
    ...mapActions(['reqTeamsList']),
    toDetail(teamCode) {
      this.$router.push({
        name: 'Detail',
        params: { id: teamCode }
      })
    },
    getTeamsInfo(seasonId) {
      // 每次切换到战队页签，都应该拉取新的数据，因为战队的排列顺序会经常变
      if(!this.token) return;
      let data = {
        
        token: this.token,
        seasonId:seasonId
      }
      this.reqTeamsList(data).then((response) => {
        if (response.status == 200) {
         
          this.teams = response.data

          // 存储本地
          // localStorage.setItem(
          //   "sausage-match:teams",
          //   JSON.stringify(this.teams)
          // );
          // 存储滚动位置
          this.setScrollPosition()
        } else {
          alert(response.data)
        }
      })
    },
    setScrollPosition() {
      // 定位滚动位置
      let scrollTop = sessionStorage?.getItem('scrollTop') || 0
      this.$nextTick(() => {
        this.$refs.teams.scrollTop = Number(scrollTop)
      })
    },
    handleFocus(teamCode, status, teamName) {
      if (!this.inRequire) {
        this.inRequire = true
        let data = {
          seasonId: this.seasonInfo.id,
          teamCode: teamCode,
          status: status ? 1 : 0
        }
        api.reqFocusStatus(this.token, data).then((response) => {
          if (response.status == 200) {
            let subTeam = this.teams.find((team) => team.teamCode == teamCode)
            subTeam.isFollowed = status ? 1 : 0
            this.$refs.prompt.setMsg(status ? '关注成功' : '取消关注成功')
          }

          this.inRequire = false
        })

        if (status) {
          // 埋点
          if (typeof tapdb == 'undefined') return
          // eslint-disable-next-line no-undef
          tapdb.trackEvent('关注', {
            '#team_id': teamName
          })
        } else {
          // 埋点
          if (typeof tapdb == 'undefined') return
          // eslint-disable-next-line no-undef
          tapdb.trackEvent('取消关注', {
            '#team_id': teamName
          })
        }
      }
    },
    cacheScroll() {
      // 缓存列表滚动位置
      if (!this.$refs.teams) return

      const scrollTop = this.$refs.teams.scrollTop
      sessionStorage && sessionStorage.setItem('scrollTop', scrollTop)
    }
  }
}
</script>


<style lang="scss" scoped>
@import '~@/assets/scss/teams/index';
</style>